import { render, staticRenderFns } from "./ContentEventsBlock.vue?vue&type=template&id=50405ba2&scoped=true"
import script from "./ContentEventsBlock.vue?vue&type=script&lang=js"
export * from "./ContentEventsBlock.vue?vue&type=script&lang=js"
import style0 from "./ContentEventsBlock.vue?vue&type=style&index=0&id=50405ba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50405ba2",
  null
  
)

export default component.exports